export default __webpack_public_path__ + "1d0ab39fbcc8b0c68d78a0f49952cb05.jpg";